import React from 'react';
import Framework from "@beardeddevops/react.framework";
import {Collections, Parts} from "components";

const breadcrumbsStatic = [{
	name: 'FE Performance',
	url: '/helpdesks/fe_performance',
	icon: 'comments'
}];

class FePerformance extends Framework.Components.View {
	render() {
		return (
			<div className={'container-fluid'}>
				<Framework.Components.PageBar breadcrumbs={breadcrumbsStatic} history={this.props.history}/>
				<Parts.Tickers.HelpdeskTicker/>
				<Collections.FePerformance
					history={this.props.history}
					regions={this.props.regions}
					roles={this.props.roles}
					reloadShell={this.props.reloadShell}
				/>
			</div>
		);
	}
}

export default Framework.Components.withRootState(FePerformance);
